import React from "react";
import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { useLanguage } from "../../../../context/LanguageContext";
import "./OurMission.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`Our mission field "${key}" is missing from the API response.`);
  }
  return value;
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    text: requireField(f, "text"),
    linkText: requireField(f, "linkText"),
    linkUrl: requireField(f, "linkUrl"),
  };
};

const isExternal = (href) => /^https?:\/\//i.test(href);

const MissionLink = ({ href, className, children }) => {
  if (isExternal(href)) {
    return (
      <a href={href} className={className} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }

  if (href.startsWith("#") || href.includes("/#")) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
};

const OurMission = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection(
    "home",
    "our-mission",
    buildModel
  );

  if (isLoading) {
    return (
      <section className="our-mission" dir={meta.dir}>
        <div className="our-mission__container">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading mission…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="our-mission" dir={meta.dir}>
        <div className="our-mission__container">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Our mission unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="our-mission" dir={meta.dir}>
      <div className="our-mission__container">
        <span className="our-mission__badge">{model.badge}</span>

        <h2 className="our-mission__title">{model.title}</h2>

        <p className="our-mission__text">{model.text}</p>

        <MissionLink href={model.linkUrl} className="our-mission__link">
          <span>{model.linkText}</span>
          <HiArrowRight />
        </MissionLink>
      </div>
    </section>
  );
};

export default OurMission;
